import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import utils from './scripts/utils';

import startCase from 'lodash/startCase';

import Index from './views/Index.vue';
import About from './views/About.vue';
import Projects from './views/Projects.vue';
import Project from './views/Project.vue';
import People from './views/People.vue';
import Person from './views/Person.vue';
import Contact from './views/Contact.vue';
import Error404 from './views/Error404.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:lang(it|en)',
      name: 'index',
      component: Index,
    },
    {
      path: '/',
      redirect: '/it',
    },
    {
      path: '/:lang/(we-are|siamo)',
      name: 'about',
      component: About,
    },
    {
      path: '/:lang/(investments|investimenti)',
      name: 'projects',
      component: Projects,
    },
    {
      path: '/:lang/(investments|investimenti)/:id',
      name: 'project',
      component: Project,
    },
    {
      path: '/:lang/(team|team)',
      name: 'people',
      component: People,
    },
    {
      path: '/:lang/(team|team)/:id',
      name: 'person',
      component: Person,
    },
    {
      path: '/:lang/(contacts|contatti)',
      name: 'contact',
      component: Contact,
    },
    {
      path: '/:lang/404',
      name: 'error404',
      component: Error404,
    },
    {
      path: '/en/*',
      redirect: '/en/404',
    },
    {
      path: '/it/*',
      redirect: '/it/404',
    },
    {
      path: '/*',
      redirect: '/it/404',
    },
  ],
});

router.beforeEach((to, from, next) => {
  const lang = typeof to.params.lang === 'undefined' ? 'it' : to.params.lang;
  store.commit('SET_LANG', lang);

  const name = to.name === 'project' || to.name === 'person' ? to.params.id : to.params.pathMatch !== undefined ? to.params.pathMatch : 'home';

  let title = name === 'home' ? 'Index' : startCase(name);

  if (to.name === 'error404') title = lang === 'it' ? 'Aiutatemi!' : 'Please Help Me!';

  document.title = `Pygar — ${title}`;

  if (store.state.menu) store.commit('TOGGLE_MENU');
  store.commit('IS_TRANS', true);

  if (!store.state.firebase) {
    store.dispatch('LOAD_DATA').then(() => {
      const checkRoute = utils.checkRoute(name);
      store.commit('SET_ROUTENAME', checkRoute);

      store.commit('SET_INIT', true);
      next();
    });
  } else {
    const checkRoute = utils.checkRoute(name);
    store.commit('SET_ROUTENAME', checkRoute);
    next();
  }
});
export default router;
